export default __webpack_public_path__ + "static/media/Summoner's Bracers of the Mandate.f583758b.jpg";